import React from 'react';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import {Card, CardText} from 'material-ui/Card';
import SearchIcon from 'material-ui/svg-icons/action/search';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem} from 'material-ui/List';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import DataFeedStore from '../stores/DataFeedStore';
import DataFeedActions from '../actions/DataFeedActions';
import PrettyJSON from './PrettyJSON.react';

const selectStyle = {
    textAlign: 'left'
}

const buttonStyle = {
    margin: 12
}

const style = {
    margin: 20,
    textAlign: 'center',
    display: 'inline-block',
    marginBottom: 50,
    height: 500
};

const textFieldStyle = {}

const refreshIndicatorStyle = {

    display: 'inline-block',
    position: 'relative',
};

function checkAgainstNull(str) {

    if (str) {

        return str;
    }

    return "";
}

const SuperContractorOrganisation = React.createClass({
    getInitialState: function () {
        let commentsForContractorsOpen = false;

        if (this.props.company.super_contractor_comments) {
            commentsForContractorsOpen = true;
        }

        return {
            auditID: 0, // needs fix
            contractors: this.props.contractors,
            neustar_open: false,
            neustar_data: this.props.company.record.neustar_raw_data,
            ipAddress: this.props.company.record.ip,
            pile_count: this.props.company.remaining,
            type_id: 7, // needs fix
            backOnThePile: false,
            id: this.props.company.record.id,
            name: this.props.company.record.name,
            website: this.props.company.record.website,
            loadingNew: DataFeedStore.isLoading(),
            tel: this.props.company.record.tel,
            linkedIn: '',
            hostname: this.props.company.record.hostname,
            companyName: this.props.company.record.end_user_company_name,
            dateTime: moment(this.props.company.record.updated_at).format('dddd, MMM Do YYYY, h:mm:ss'),
            remaining: this.props.company.remaining,
            missingFields: [],
            system_type_id: 1,
            neustar_original_name: '', // needs fix,
            superContractorComments2: '',
            backOnThePileDialogOpen: false,
            superContractorComments: this.props.company.record.super_contractor_comments,
            commentsForContractorsOpen: commentsForContractorsOpen,
            missingDataDialogOpen: false,
            complicatedRecordDialog: false,
            isComplicated: false,
            reasonComplicated: this.props.company.record.reason_complicated,
            contractorComments: '', // needs fix
            missingData: false,
            organisationId: this.props.company.record.organisation_id,
            ref: {
                contractorName: this.props.company.record.contractor_username, // needs fix
                name: this.props.company.record.name,
                website: this.props.company.record.website,
                tel: this.props.company.record.tel,
                type_id: 7, // needs fix
                linkedIn: '',
                hostname: this.props.company.record.hostname,
                companyName: this.props.company.record.end_user_company_name,
                location: `${this.props.company.record.city}, ${this.props.company.record.country}`,
            },
            contractor_to_view_data_for: DataFeedStore.getContractorToViewDataFor(),
            filter_by_organisation_type_id: DataFeedStore.getFilterByOrganisationTypeID()
        }
    },

    componentDidMount: function () {

        DataFeedActions.loadContractors();
    },

    componentWillReceiveProps: function (nextProps) {
        let commentsForContractorsOpen = false;

        if (nextProps.company.super_contractor_comments) {
            commentsForContractorsOpen = true;
        }

        let newState = {
            contractor_to_view_data_for: DataFeedStore.getContractorToViewDataFor(),
            auditID: 0, // needs fix
            contractors: nextProps.contractors,
            sanitizedDate: moment(nextProps.company.record.updated_at).format('dddd, MMM Do YYYY, h:mm:ss'),
            neustar_data: nextProps.company.record.neustar_raw_data,
            ipAddress: nextProps.company.record.ip,
            id: nextProps.company.record.id,
            name: nextProps.company.record.name,
            website: nextProps.company.record.website,
            tel: nextProps.company.record.tel,
            linkedIn: '',
            hostname: nextProps.company.record.hostname,
            companyName: nextProps.company.record.end_user_company_name,
            type_id: 7, // needs fix
            loadingNew: DataFeedStore.isLoading(),
            organisationId: nextProps.company.record.organisation_id,
            dateTime: moment(nextProps.company.record.updated_at).format('dddd, MMM Do YYYY, h:mm:ss'),
            remaining: nextProps.company.remaining,
            neustar_original_name: '', // needs fix
            system_type_id: 1,
            pile_count: nextProps.company.remaining,
            superContractorComments: '',
            commentsForContractorsOpen: commentsForContractorsOpen,
            contractorComments: '',

            ref: {
                contractorName: nextProps.company.record.contractor_username,
                name: nextProps.company.record.name,
                website: nextProps.company.record.website,
                tel: nextProps.company.record.tel,
                linkedIn: '',
                hostname: nextProps.company.record.hostname,
                companyName: nextProps.company.record.name,
                location: `${nextProps.company.record.city}, ${nextProps.company.record.country}`,
                type_id: 7,
            },

            filter_by_organisation_type_id: DataFeedStore.getFilterByOrganisationTypeID()
        }

        if (this.props.company.id !== nextProps.company.id) {
            newState.superContractorComments2 = '';
            newState.complicatedRecordDialog = false;
            newState.isComplicated = false;
            newState.reasonComplicated = '';
            newState.missingDataReason = '';
            newState.missingFields = [];
            newState.missingDataDialogOpen = false;
            newState.backOnThePileDialogOpen = false;
            newState.superContractorComments = '';
            newState.backOnThePile = false;
        }

        this.setState(newState);
    },

    onChangeOrganisationName: function (newVal) {

        this.setState({name: newVal.target.value});
    },

    onChangeWebsite: function (newVal) {

        this.setState({website: newVal.target.value});

    },

    handleSector: function (event, index, value) {

        var newState = {

            type_id: value
        }

        if (value === 7) {

            newState.isComplicated = false
            newState.complicatedRecordDialog = true;

        } else if (value === 9) {

            newState.isComplicated = false;
            newState.reasonComplicated = '';
        }

        this.setState(newState);
    },

    onChangeTel: function (newVal) {

        this.setState({

            tel: newVal.target.value
        });
    },

    onChangeLinkedIn: function (newVal) {

        this.setState({

            linkedIn: newVal.target.value
        });
    },

    onChangeHostname: function (newVal) {

        this.setState({

            hostname: newVal.target.value
        })
    },

    searchOrgName: function () {

        window.open('http://www.google.co.uk/search?q=' + this.state.name, '_blank');
    },

    searchWebsite: function () {

        window.open('http://www.google.co.uk/search?q=' + this.state.website, '_blank');
    },

    searchHostname: function () {

        window.open('http://www.google.co.uk/search?q=' + this.state.hostname, '_blank');
    },

    viewNeustarData: function () {

        this.setState({

            neustar_open: true
        })
    },

    setMissingDataReason: function (event) {

        var missingDataReason = event.target.value;

        if (missingDataReason.trim().length > 0) {

            this.setState({

                valid: true,
                missingDataReason: missingDataReason
            })
        }
    },

    handleClose: function () {

        this.setState({

            neustar_open: false
        })
    },

    handleCloseMissingDataDialog: function () {

        this.setState({

            missingDataDialogOpen: false
        })
    },

    handleCloseComplicatedRecordDialog: function () {
        this.setState({
            complicatedRecordDialog: false
        })
    },
    setComplicatedReason: function (event) {
        var value = event.target.value;

        this.setState({
            reasonComplicated: value,
            isComplicated: true
        });
    },
    closeComplicatedRecord: function () {
        this.setState({
            complicatedRecordDialog: false
        })
    },
    cancelSetComplicatedRecord: function () {
        this.setState({
            type_id: 0,
            complicatedRecordDialog: false
        })
    },
    render: function () {
        var displayDate = this.state.dateTime;

        var missingFields = this.state.missingFields.map(function (missingField, i) {
            return (
                <p key={i}>The field "{missingField}" is missing</p>
            )
        });

        const dialogActions = [

            <FlatButton
                label="Close"
                secondary={true}
                onTouchTap={this.handleClose}/>
        ];

        const complicatedRecordOptions = [

            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.cancelSetComplicatedRecord}
            />,

            <FlatButton
                label="Set Reason"
                primary={true}
                onTouchTap={this.closeComplicatedRecord}
            />

        ];

        const missingDataDialogActions = [

            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleCloseMissingDataDialog}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onTouchTap={this._saveRecordMissingData}
            />
        ];

        const backOnThePileActions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.closeBackOnPileDialog}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onTouchTap={this._saveBackOnThePileRecord}
            />
        ];

        var organisationName = "";

        if (typeof this.state.name !== "undefined") {
            var stringArray = this.state.name.split(" ");
            var returnString = stringArray.map(function (word, i) {
                if (word.indexOf("ftip") === -1) {
                    return word;
                } else {
                    return "";
                }
            })

            organisationName = returnString.join(" ");
        }

        var website = this.state.website;
        var tel = this.state.tel;

        if (typeof website !== "undefined" && website.trim() === ".") {
            website = "";
        }

        const sanitizedInfo = (
            <div>
                <p><strong>Logged in as Super Contractor</strong></p>
                <p>Sanitized
                    by <strong>{this.state.ref.contractorName}</strong> on {this.state.sanitizedDate}
                </p>
                <p>{this.state.remaining} records remaining</p>
            </div>
        )

        let contractorOptions = this.state.contractors.map(function (contractor, c) {
            return (
                <option key={c} value={contractor.id}>{contractor.forename} {contractor.surname}</option>
            )
        });

        var downloadLink = '/download/by-type/' + this.state.filter_by_organisation_type_id;

        var remaining = (

            <div className="row">

                <div className="col-md-6">
                    {sanitizedInfo}
                </div>

                <div className="col-md-6">

                    <div className="row">

                        <div className="col-md-10">

                            {/*<div className="form-group">*/}
                            {/*    <label>Business Type</label>*/}
                            {/*    <select*/}
                            {/*        className="form-control"*/}
                            {/*        value={this.state.filter_by_organisation_type_id}*/}
                            {/*        onChange={this._setOrganisationTypeToView}*/}
                            {/*        id="businessType"*/}
                            {/*    >*/}
                            {/*        <option value={0}>All</option>*/}
                            {/*        <option value={1}>Business</option>*/}
                            {/*        <option value={2}>Education</option>*/}
                            {/*        <option value={3}>ISP</option>*/}
                            {/*        <option value={4}>Crawlbot</option>*/}
                            {/*        <option value={5}>Public</option>*/}
                            {/*        <option value={6}>Unknown</option>*/}
                            {/*    </select>*/}
                            {/*</div>*/}
                        </div>

                        <div className="col-md-2">

                            {/*<a href={downloadLink}>*/}
                            {/*    <DownloadIcon style={{color: 'green', marginTop: 30}}/>*/}
                            {/*</a>*/}
                        </div>
                    </div>

                    <div className="clr"></div>

                    {/*<div className="row">*/}

                    {/*    <div className="col-md-10">*/}

                    {/*        <div className="form-group">*/}
                    {/*            <select className="form-control"*/}
                    {/*                    onChange={this._setContractor}*/}
                    {/*                    value={this.state.contractor_to_view_data_for}*/}
                    {/*                    id="contractorIndividual">*/}
                    {/*                <option value={-1}>---- Contractor ----</option>*/}
                    {/*                {contractorOptions}*/}
                    {/*            </select>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                    {/*</div>*/}

                </div>
            </div>
        );


        var neustarData = [];

        if (this.state.neustar_data) {
            neustarData = JSON.parse(JSON.stringify(JSON.parse(this.state.neustar_data)));
        }

        let commentsForContractor = "";

        if (this.state.contractorComments !== "") {
            commentsForContractor = (
                <div>
                    <TextField
                        fullWidth={true}
                        floatingLabelText="Contractor Comments for Super Contractor"
                        multiLine={true}
                        rows={5}
                        value={this.state.contractorComments}
                    />
                    <div className="clr"></div>
                    <br/>
                </div>
            )
        }

        var companyRecord = (

            <div className="companyRecord">

                <Card>

                    <CardText>

                        <div className="row">

                            <div className="col-md-12">

                                {remaining}
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-md-12">

                                <div className="col-md-4">

                                    <Paper style={style} zDepth={5}>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(neustarData.ipinfo.Network.organization)}
                                            disabled={true}
                                            floatingLabelText="Organisation Neustar Name"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(this.state.ref.hostname)}
                                            disabled={true}
                                            floatingLabelText="Hostname"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(this.state.ipAddress)}
                                            disabled={true}
                                            floatingLabelText="IP Address"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(displayDate)}
                                            disabled={true}
                                            floatingLabelText="Date / Time"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(this.state.companyName)}
                                            disabled={true}
                                            floatingLabelText="Subscriber"/>

                                        <SelectField
                                            value={this.state.system_type_id}
                                            autoWidth={true}
                                            floatingLabelText="Algorithm Sector Type"
                                            style={selectStyle}
                                            disabled={true}>

                                            <MenuItem value={0} primaryText="Select"/>
                                            <MenuItem value={1} primaryText="Company"/>
                                            <MenuItem value={2} primaryText="Education"/>
                                            <MenuItem value={3} primaryText="ISP"/>
                                            <MenuItem value={4} primaryText="Crawl Bot"/>
                                            <MenuItem value={5} primaryText="Public"/>
                                            <MenuItem value={6} primaryText="Unknown"/>
                                        </SelectField>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(this.state.ref.location)}
                                            disabled={true}
                                            floatingLabelText="Location"/>

                                    </Paper>

                                </div>

                                <div className="col-md-4">

                                    <Paper style={style} zDepth={5}>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(organisationName)}
                                            onChange={this.onChangeOrganisationName}
                                            floatingLabelText="Contractor set Name"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(website)}
                                            onChange={this.onChangeWebsite}
                                            floatingLabelText="Contractor set Website"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={checkAgainstNull(tel)}
                                            onChange={this.onChangeTel}
                                            floatingLabelText="Contractor set Telephone"/>


                                        <SelectField value={this.state.type_id}
                                                     floatingLabelText="Contractor set Sector" autoWidth={true}
                                                     style={selectStyle} onChange={this.handleSector}>
                                            <MenuItem value={0} primaryText="Select"/>
                                            <MenuItem value={1} primaryText="Company"/>
                                            <MenuItem value={2} primaryText="Education"/>
                                            <MenuItem value={3} primaryText="ISP"/>
                                            <MenuItem value={4} primaryText="Crawl Bot"/>
                                            <MenuItem value={5} primaryText="Public"/>
                                            <MenuItem value={6} primaryText="Unknown"/>
                                            <MenuItem value={7} primaryText="Complicated"/>
                                        </SelectField>

                                        <div className="clr"></div>
                                        <br/>

                                        <RaisedButton label="Commit" onClick={this._saveRecord} secondary={true}
                                                      style={buttonStyle}/>
                                        <RaisedButton label="Back on the Pile" onClick={this._backOnToThePile}
                                                      primary={true} style={buttonStyle}/>

                                    </Paper>
                                </div>

                                <div className="col-md-4">

                                    <List>
                                        <ListItem onClick={this.searchOrgName} primaryText="Search Organisation Name"
                                                  leftIcon={<SearchIcon/>}/>
                                        <ListItem onClick={this.searchHostname} primaryText="Search Hostname"
                                                  leftIcon={<SearchIcon/>}/>
                                        <ListItem onClick={this.searchWebsite} primaryText="Search Website"
                                                  leftIcon={<SearchIcon/>}/>
                                        <ListItem onClick={this.viewNeustarData} primaryText="View Neustar Data"
                                                  leftIcon={<InfoIcon/>}/>
                                    </List>

                                    <div className="clr"></div>
                                    <br/>

                                    {/*<TextField*/}
                                    {/*    fullWidth={true}*/}
                                    {/*    floatingLabelText="Comments for contractor"*/}
                                    {/*    onChange={this._setCommentsForContractor}*/}
                                    {/*    multiLine={true}*/}
                                    {/*    rows={10}*/}
                                    {/*/>*/}
                                </div>
                            </div>
                        </div>
                    </CardText>
                </Card>

                <Dialog open={this.state.backOnThePileDialogOpen} title="Back on the Pile Reason"
                        onRequestClose={this.closeBackOnPileDialog} actions={backOnThePileActions}>

                    <TextField
                        fullWidth={true}
                        floatingLabelText="Please explain why you are placing record back on the pile"
                        onChange={this._setBackOnThePileReason}
                        multiLine={true}
                        rows={4}
                    />

                </Dialog>

                <Dialog title="Missing Data" onRequestClose={this.handleCloseMissingDataDialog}
                        actions={missingDataDialogActions} open={this.state.missingDataDialogOpen}>

                    {missingFields}

                    <br/>

                    <TextField
                        fullWidth={true}
                        floatingLabelText="Please explain why record submitted with incomplete data"
                        onChange={this.setMissingDataReason}
                        multiLine={true}
                        rows={4}
                    />
                </Dialog>

                <Dialog
                    title="Raw Data"
                    onRequestClose={this.handleClose}
                    actions={dialogActions}
                    autoScrollBodyContent={true}
                    open={this.state.neustar_open}
                >
                    <PrettyJSON data={neustarData}/>
                </Dialog>

                <Dialog title="Complicated Record" onRequestClose={this.handleCloseComplicatedRecordDialog}
                        open={this.state.complicatedRecordDialog} actions={complicatedRecordOptions}>

                    <TextField
                        fullWidth={true}
                        floatingLabelText="Reason why record is complicated"
                        onChange={this.setComplicatedReason}
                        multiLine={true}
                        rows={4}
                    />
                </Dialog>

            </div>
        );

        var content = '';

        if (this.state.loadingNew) {

            content = (

                <RefreshIndicator
                    size={50}
                    left={70}
                    top={0}
                    loadingColor={"#FF9800"}
                    status="loading"
                    style={refreshIndicatorStyle}/>
            );

        } else {

            content = companyRecord;
        }


        return (


            <div className="organisation">

                {content}
            </div>
        )
    },

    _setCommentsForContractor: function (event, newVal) {
        this.setState({
            superContractorComments2: newVal
        })
    },

    _setOrganisationTypeToView: function (event) {

        DataFeedActions.setOrganisationTypeToView(event.target.value);
    },
    _setContractor: function (event) {
        DataFeedActions.setContractorToViewDataFor(event.target.value);
    },
    _closeCommentsForContractor: function () {
        this.setState({
            commentsForContractorsOpen: false
        })
    },
    _saveBackOnThePileRecord: function () {
        DataFeedActions.setLoading(true);

        var newState = JSON.parse(JSON.stringify(this.state));
        newState.backOnThePile = true;
        newState.backOnThePileDialogOpen = false;

        this.setState(newState);

        DataFeedActions.editOrganisation({
            id: newState.organisationId,
            recordId: this.state.id,
            storedValue: newState
        });
    },

    _setBackOnThePileReason: function (event) {
        this.setState({
            superContractorComments: event.target.value
        })
    },
    closeBackOnPileDialog: function () {
        this.setState({
            backOnThePileDialogOpen: false
        })
    },
    _backOnToThePile: function () {
        this.setState({
            backOnThePileDialogOpen: true
        })
    },
    _saveRecordMissingData: function () {
        DataFeedActions.setLoading(true);

        this.setState({
            backOnThePile: false,
            backOnThePileDialogOpen: false
        })

        DataFeedActions.editOrganisation({

            id: this.state.id,
            storedValue: this.state
        });
    },

    _saveRecord: function () {
        var required = [
            'name',
            'tel',
            'website'
        ]

        var displayFieldNames = {

            name: 'Organisation Name',
            tel: 'Telephone Number',
            website: 'Website'
        }

        var valid = true;

        var missingVals = [];

        required.map(function (val, i) {

            if (typeof this.state[val] === "undefined" ||
                this.state[val].trim() === "") {

                valid = false;

                missingVals.push(displayFieldNames[val]);
            }

        }.bind(this));

        if (!valid && !this.state.isComplicated && this.state.type_id != 3) {

            this.setState({

                missingDataDialogOpen: true,
                missingData: true,
                missingFields: missingVals
            })

        } else {

            this.setState({

                missingData: false,
                missingDataDialogOpen: false,

            })

            DataFeedActions.setLoading(true);

            DataFeedActions.editOrganisation({
                id: newState.organisationId,
                recordId: this.state.id,
                storedValue: this.state
            });
        }
    }
});

export default SuperContractorOrganisation;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/SuperContractorOrganisation.react.js